export enum AppRoutes {
    LANDING = "landing",
    MAINRU = "mainru",
    MAIN = "main",
    LOGIN = "login",
    GOOGLE_CALLBACK = "google_callback",
    WATCH_LINK = "watch_link",
    WATCH_LINK_DONE = "watch_link_done",
    // Вход переводчика эфира в редактор /fast (translate-tts, свой домен): страница выдаёт
    // одноразовый код и возвращает браузер в редактор (см. EditorLinkPage).
    EDITOR_LINK = "editor_link",
    PLAYER = "player",
    PLAYER_MEDIA = "player_media", // New: for player with mediaId
    // The 1:1 conversation, as its OWN page rather than a mode of the watch
    // page. The broadcast and the call run on different clocks -- one is minutes
    // behind, the other is now -- and sharing a surface meant promotion moved a
    // viewer through time without telling them. Reached by a link the admin
    // sends, because a 1:1 is rare and someone already decides who is in one.
    LIVE_CALL = "live_call",
    DEVICE_CHECK = "device_check",
    ADMIN_STREAM = "admin_stream",
    CALCULATOR = "calc",
    RAG = "rag",
    TermsAndConditions = "terms-and-conditions",
    ACCOUNT = "account",
    COURSE = "course",
    BUCKET_FILES = "bucket-files",
    YOUTUBE_VIDEOS = "youtube-videos",
    WORKOUT_REVIEW = "workout-review",
    ACTIVITY_REVIEW = "activity-review",
    LEAGUE = "league",
    // «Лига участников» /:lang/account/league-users/* — пока только
    // администраторам. Свой плоский маршрут, а не ребёнок ACCOUNT: всем
    // остальным адрес отвечает голым «404», как до страницы (см. LeagueUsersRoute).
    LEAGUE_USERS = "league_users",
    // v5-products: «Все продукты» /:lang/account/products — пока только администраторам.
    // Плоский маршрут, как LEAGUE_USERS: всем остальным адрес отвечает голым «404»
    // (см. ProductsRoute).
    PRODUCTS = "products",
    // «Достижения» /:lang/account/achievements — пока предпросмотр для администраторов.
    // Плоский маршрут, как LEAGUE_USERS: всем остальным адрес отвечает голым «404»
    // (см. AchievementsRoute).
    ACHIEVEMENTS = "achievements",
    ADMIN_MARATHONS = "admin-marathons",
    // Админка марафонов лиги /:lang/admin/marathons/* — только администраторам
    // (гейт внутри страницы по /api/league/marathons/manage/me).
    ADMIN_LEAGUE_MARATHONS = "admin-league-marathons",
    ADMIN_CLUBS_RADIUS = "admin-clubs-radius",
    PLAN_CREATE = "plan-create",
    CLUB_MANAGER = "club-manager",
    // Кабинет клуба (03.11): ссылка-приглашение в клуб и админская страница клубов
    // («Я веду этот клуб», предложения открыть клуб, заявки в клубы без руководителя).
    CLUB_INVITE = "club-invite",
    ADMIN_CLUBS = "admin-clubs",
    HEALTHE_GUIDE = "health-guide",
    ANSWER = "answer",
    ACTIVITIES_MAP = "activities-map",
    PRIVACY_POLICY = "privacy-policy",
    FIT_UPLOAD = "fit-upload",
    SCORING_ANALYSIS = "scoring-analysis",
    ADMIN_DASHBOARD = "admin",
    ADMIN_USER_PROFILE = "admin-user-profile",
    ADMIN_USER_PROFILE_BY_UID = "admin-user-profile-by-uid",
    LECTURES = "lectures",
    CUT_VIDEOS = "cut-videos",
    CUT_VIDEO = "cut-video",
    CUT_PREVIEW = "cut-preview",
    CUT_PREVIEW_ONE = "cut-preview-one",
    CLIP_CUTS = "clip-cuts",
    COURSE_CUTS = "course-cuts",
    CLIP_CUT_ONE = "clip-cut-one",
    INDIA_VIDEO_ANSWER = "india-video-answer",
    ADMIN_DIRECT_ANSWER = "admin-direct-answer",
    ADMIN_CLIP_INSERTS = "admin-clip-inserts",
    DIAGNOSTIC_QUESTIONNAIRE = "diagnostic-questionnaire",
    ORDER_AFTER_PAY = "order-after-pay",
    PAYMENT_SUCCESS = "payment-success",
    REVIEWS = "reviews",
    ACCOUNT_ACTIVITIES = "account-activities",
    ACTIVITY_DETAIL = "activity-detail",
    // The gathering calendar has no entry here any more: it merged into the
    // workouts calendar (an ACCOUNT child). Build its URL with
    // getRouteWorkoutsCalendar(); /account/activities-calendar stays as a redirect.
    ADMIN_GEO_DENSITY = "admin-geo-density",
    MY_REVIVE = "my-revive",
    USER_QUESTIONS = "user-questions",
    USER_QUESTION_DETAIL = "user-question-detail",
    ADMIN_REJECT_REASONS = "admin-reject-reasons",
    QUESTION_DATABASE = "question-database",
    ANSWER_CORRECTIONS = "answer-corrections",
    ANSWER_CORRECTION_EDITOR = "answer-correction-editor",
    SUBTITLE_CORRECTIONS = "subtitle-corrections",
    SUBTITLE_CHANGELOG = "subtitle-changelog",
    GLOSSARY = "glossary",
    ADMIN_CRASH_REPORTS = "admin-crash-reports",
    ADMIN_MODERATION = "admin-moderation",
    ADMIN_COURSE_QA = "admin-course-qa",
    ADMIN_ERROR_REPORTS = "admin-error-reports",
    ADMIN_COMMUNITY = "admin-community",
    ACCOUNT_SETTINGS = "account-settings",
    ACCOUNT_PROFILE = "account-profile",
    ACCOUNT_NOTIFICATIONS = "account-notifications",
    ACCOUNT_SPECIALIST_CHAT = "account-specialist-chat",
    ACCOUNT_KNOWLEDGE = "account-knowledge",
    HEALTH_METHOD_COURSE = "health-method-course",
    PRIVACY_POLICY_PUBLIC = "privacy_policy",
    DELETE_ACCOUNT = "delete-account",
    PRIVACY_ALIAS = "privacy",
    TERMS_ALIAS = "terms",
    CANCELLATION_POLICY = "cancellation_policy",
    TRANSLATED_LECTURES = "translated-lectures",
    OGT_MAIN_PAGE = "ogt-main-page",
    PERSONAL_CONSULTATION = "personal-consultation",
    SUPPORT = "support",
    ABOUT_OGT = "about-ogt",
    VERIFY_EMAIL = "verify-email",
    CONFIRM_PURCHASE = "confirm-purchase",
    SET_PASSWORD = "set-password",
    QUESTIONS_PUBLIC = "questions-public",
    MY_COURSES_NEW = "my-courses-new",
    MY_COURSES_NEW_GROUP = "my-courses-new-group",
    MY_COURSES_NEW_DETAIL = "my-courses-new-detail",
    MY_COURSES_NEW_LESSON = "my-courses-new-lesson",
    BLAGOST_CLUBS = "blagost-clubs",
    AI_SEARCH = "ai-search",
    BUY_COURSE = "buy-course",
    BUY_SUBSCRIPTION = "buy-subscription",
    MANUAL_HUB = "manual-hub",
    MANUAL = "manual",
    ADMIN_COURSE_PAYMENTS = "admin-course-payments",
    ADMIN_COUPONS = "admin-coupons",
    ADMIN_LIVE_STAGE = "admin-live-stage",
    ADMIN_SHOW = "admin-show",
    ADMIN_SUBSCRIPTIONS = "admin-subscriptions",
    ADMIN_GOOGLEPLAY_PROMOS = "admin-googleplay-promos",
    ADMIN_TESTING = "admin-testing",
    ADMIN_PERSONAL_CONSULTATION = "admin-personal-consultation",
    PACKAGES = "packages",
    // Подарок по ссылке: страница получателя /:lang/gift (открыта всем) и
    // «Мои подарки» покупателя /:lang/account/gifts (пока только админам).
    GIFT = "gift",
    MY_GIFTS = "my-gifts",
    VIDEO_COURSE = "video-course",
    TELEGRAM_ACCESS = "telegram-access",
    METHOD = "method",
    // «Скачать приложение» /:lang/get-app?r=ru|world&c=<место> — сюда ведёт QR
    // окна магазинов умной кнопки (shared/ui/SmartStoreButton). Открыта всем.
    GET_APP = "get-app",
    // last
    NOT_FOUND = "not_found",
}

// Basic route getters
export const getRouteMain = (lang = "ru") => `/${lang}`;
export const getRouteLogin = (lang = "ru") => `/${lang}/login`;
export const getRouteTelegramAccess = (lang = "ru") => `/${lang}/telegram-access`;
// Витрина метода для своих: сама страница статическая, в public/method/.
export const getRouteMethod = (lang = "ru") => `/${lang}/method`;
// Одна умная кнопка магазина; ?r= — регион, выбранный на компьютере (QR).
export const getRouteGetApp = (lang = "ru") => `/${lang}/get-app`;
export const getRouteCalculator = (lang = "ru") => `/${lang}/calc`;
export const getRouteRag = (lang = "ru") => `/${lang}/rag`;
export const getRouteTermsAndConditions = (lang = "ru") =>
    `/${lang}/terms-and-conditions`;
export const getRouteBucketFiles = (lang = "ru") => `/${lang}/bucket-files`;
export const getRouteCourse = (lang = "ru") => `/${lang}/course`;
export const getRouteYouTubeVideos = (lang = "ru") => `/${lang}/youtube-videos`;
export const getRouteMyRevive = (lang = "ru") => `/${lang}/my-revive`;
export const getRouteAdminCrashReports = (lang = "ru") =>
    `/${lang}/admin-crash-reports`;
export const getRouteAdminModeration = (lang = "ru") =>
    `/${lang}/admin-moderation`;
export const getRouteAdminCommunity = (lang = "ru") =>
    `/${lang}/admin-community`;
export const getRouteBuyCourse = (lang = "ru", courseId: string) =>
    `/${lang}/buy/${courseId}`;
export const getRouteBuySubscription = (lang = "en") =>
    `/${lang}/buy-subscription`;
export const getRouteManualHub = (lang = "ru") => `/${lang}/manual`;
export const getRouteManual = (lang = "ru", platform: string) =>
    `/${lang}/manual/${platform}`;
export const getRouteAdminCoursePayments = (lang = "ru") =>
    `/${lang}/admin/course-payments`;
export const getRouteAdminCoupons = (lang = "ru") =>
    `/${lang}/admin/coupons`;
export const getRouteAdminSubscriptions = (lang = "ru") =>
    `/${lang}/admin/subscriptions`;
export const getRouteAdminGooglePlayPromos = (lang = "ru") =>
    `/${lang}/admin/googleplay-promos`;
/** Админка марафонов лиги; sub — «new», «<id>» или пусто. */
export const getRouteAdminLeagueMarathons = (lang = "ru", sub = "") =>
    `/${lang}/admin/marathons${sub ? "/" + sub : ""}`;
export const getRouteAdminPersonalConsultation = (lang = "ru", id?: string) =>
    id
        ? `/${lang}/admin/personal-consultation/${encodeURIComponent(id)}`
        : `/${lang}/admin/personal-consultation`;
export const getRouteHealthMethodCourse = (lang = "ru") =>
    `/${lang}/health-method-course`;
export const getRouteVideoCourse = (lang = "ru") => `/${lang}/video-course`;
export const getRouteWorkoutReview = (lang = "ru") => `/${lang}/workout-review`;
export const getRouteActivityReview = (lang = "ru") => `/${lang}/activity-review`;
export const getRouteLeague = (lang = "ru") => `/${lang}/league`;
// v5-products: «Все продукты» (только администраторам, ProductsRoute).
export const getRouteProducts = (lang = "ru") => `/${lang}/account/products`;
export const getRouteAnswer = (lang = "ru") => `/${lang}/answer`;
export const getRouteActivitiesMap = (lang = "ru") => `/${lang}/activities-map`;
export const getRoutePrivacyPolicy = (lang = "ru") => `/${lang}/privacy-policy`;
export const getRouteFitUpload = (lang = "ru") => `/${lang}/account/fit-upload`;
export const getRouteScoringAnalysis = (lang = "ru") =>
    `/${lang}/scoring-analysis`;
export const getRouteAdminDashboard = (lang = "ru") => `/${lang}/admin`;
export const getRouteAdminUserProfile = (lang = "ru", email: string) =>
    `/${lang}/admin/users/${encodeURIComponent(email)}`;
export const getRouteAdminUserProfileByUid = (lang = "ru", uid: string) =>
    `/${lang}/admin/users/uid/${encodeURIComponent(uid)}`;

export const getRouteCutVideos = (lang = "ru") => `/${lang}/cut-videos`;
export const getRouteCutVideo = (lang = "ru", cutId: string) =>
    `/${lang}/cut-videos/${cutId}`;
export const getRouteCutPreview = (lang = "ru") => `/${lang}/cut-preview`;
export const getRouteCutPreviewOne = (lang = "ru", cutId: string) =>
    `/${lang}/cut-preview/${cutId}`;
export const getRouteLectures = (lang = "ru") => `/${lang}/account/lectures`;
export const getRouteIndiaVideoAnswer = (lang = "ru") =>
    `/${lang}/india-video-answer`;

export const getRouteAdminDirectAnswer = (lang = "ru") =>
    `/${lang}/admin-direct-answer`;
export const getRouteDiagnosticQuestionnaire = (lang = "ru") =>
    `/${lang}/account/questionnaire`;
export const getRouteOrderAfterPay = (lang = "ru") =>
    `/${lang}/account/health-details`;
export const getRoutePaymentSuccess = (lang = "ru") =>
    `/${lang}/account/payment-success`;
export const getRouteReviews = (lang = "ru") => `/${lang}/account/reviews`;
export const getRouteAccountActivities = (lang = "ru") =>
    `/${lang}/account/activities`;

export const getRouteActivityDetail = (lang = "ru", id: string) =>
    `/${lang}/account/activity/${id}`;
/**
 * Единый календарь кабинета: тренировки, план и встречи на одной сетке.
 * `day` — «YYYY-MM-DD»: открыть сразу на этом дне (`?d=`), как умел календарь встреч.
 */
export const getRouteWorkoutsCalendar = (lang = "ru", day?: string) =>
    `/${lang}/account/workouts${day ? `?d=${day}` : ""}`;
// Календаря встреч как отдельной страницы больше нет — он слился с календарём
// тренировок. Старый адрес /account/activities-calendar остаётся редиректом,
// а всё, что строит ссылку через этот геттер, ведёт сразу на общий календарь.
export const getRouteActivitiesCalendar = (lang = "ru") =>
    getRouteWorkoutsCalendar(lang);
/**
 * «Зоны пульса и длина шага»: по каким тренировкам посчитаны зоны и длина
 * шага. Часы и приложения открывают этот адрес с одноразовым кодом входа (&code=).
 */
export const getRouteTrainingBasis = (lang = "ru", tab?: "hr" | "stride") =>
    `/${lang}/account/training-basis${tab ? `?tab=${tab}` : ""}`;

export const getRouteAdminGeoDensity = (lang = "ru") =>
    `/${lang}/admin/geo-density`;
export const getRouteAccountConsultations = (lang = "ru") =>
    `/${lang}/account/consultations`;
export const getRouteQuestionDatabase = (lang = "ru") =>
    `/${lang}/question-database`;
export const getRouteAnswerCorrections = (lang = "ru") =>
    `/${lang}/answer-corrections`;
export const getRouteAnswerCorrectionEditor = (lang = "ru", uuid: string) =>
    `/${lang}/answer-corrections/${uuid}`;
export const getRouteUserQuestions = (lang = "ru") => `/${lang}/user-questions`;
export const getRouteUserQuestionDetail = (lang = "ru", id: string) =>
    `/${lang}/user-questions/${id}`;
export const getRouteAdminRejectReasons = (lang = "ru") =>
    `/${lang}/admin/reject-reasons`;
export const getRouteAccountSettings = (lang = "ru") =>
    `/${lang}/account/settings`;
export const getRouteAccountNotifications = (lang = "ru") =>
    `/${lang}/account/notifications`;
export const getRouteSpecialistChat = (lang = "ru") => `/${lang}/account/specialist-chat`;
export const getRouteKnowledge = (lang = "ru") => `/${lang}/account/knowledge`;
/** Страница профиля кабинета — туда ведёт «Указать город» с домашней страницы общения. */
export const getRouteAccountProfile = (lang = "ru") => `/${lang}/account/profile`;
export const getRouteSubtitleCorrections = (lang = "ru") =>
    `/${lang}/subtitle-corrections`;
/** «Сообщения об ошибках» — разбор сообщений «Нашли ошибку?» администратором. */
export const getRouteAdminErrorReports = (lang = "ru") => `/${lang}/admin/error-reports`;
export const getRouteSubtitleChangelog = (lang = "ru") =>
    `/${lang}/subtitle-changelog`;
export const getRoutePrivacyPolicyPublic = (lang = "ru") => `/${lang}/privacy_policy`;
export const getRouteCancellationPolicy = (lang = "ru") => `/${lang}/cancellation_policy`;
export const getRouteTranslatedLectures = (lang = "ru") =>
    `/${lang}/translated-lectures`;
export const getRouteOgtMainPage = (lang = "ru") => `/${lang}/ogt-main-page`;
export const getRoutePersonalConsultation = (lang = "ru") =>
    `/${lang}/personal-consultation`;
export const getRouteSupport = (lang = "ru") => `/${lang}/support`;
export const getRouteAboutOgt = (lang = "en") => `/${lang}/about-ogt`;
export const getRouteVerifyEmail = (lang = "ru") => `/${lang}/verify-email`;
/** Ссылка из письма о покупке: пароль из оформления начинает работать (пароль после письма). */
export const getRouteConfirmPurchase = (lang = "ru") => `/${lang}/confirm-purchase`;
export const getRouteSetPassword = (lang = "ru") => `/${lang}/set-password`;
/**
 * Развилка «Ответы на вопросы». Записи в enum AppRoutes у неё нет намеренно:
 * enum описывает маршруты верхнего уровня, а это дочерний маршрут кабинета —
 * ровно как соседний /account/questions. Хелпер при этом есть, чтобы адрес не
 * собирался строкой по всему коду, как это вышло у соседа.
 */
export const getRouteAccountAnswers = (lang = "ru") => `/${lang}/account/answers`;
export const getRouteTestingWorkout = (lang = "ru") => `/${lang}/account/testing-workout`;
export const getRouteQuestionsPublic = (lang = "ru") => `/${lang}/questions`;
export const getRouteMyCoursesNew = (lang = "ru") =>
    `/${lang}/account/my-courses-new`;
/** Landing for a course sold in several formats / parts. Sits on its own
 *  `/group/` segment so a groupId can never collide with a real courseId
 *  on the `/my-courses-new/:courseId` route. */
export const getRouteMyCoursesNewGroup = (lang = "ru", groupId: string) =>
    `/${lang}/account/my-courses-new/group/${groupId}`;
export const getRouteMyCoursesNewDetail = (lang = "ru", courseId: string) =>
    `/${lang}/account/my-courses-new/${courseId}`;
export const getRouteMyCoursesNewLesson = (
    lang = "ru",
    courseId: string,
    lessonId: string,
) => `/${lang}/account/my-courses-new/${courseId}/${lessonId}`;
export const getRouteCommunity = (lang = "ru") => `/${lang}/account/community`;
export const getRouteCommunityGroup = (lang = "ru", groupId: string) =>
    `/${lang}/account/community/group/${groupId}`;
export const getRouteCommunityGroupCreate = (lang = "ru") =>
    `/${lang}/account/community/group_create`;
// Люди и друзья — дети ACCOUNT рядом с community/*, как и календарь встреч:
// записей в enum у них нет, потому что routeConfig — полный Record<AppRoutes>
// и каждая запись потребовала бы второго, плоского маршрута на тот же адрес.
export const getRouteCommunityChats = (lang = "ru") =>
    `/${lang}/account/community/chats`;
export const getRouteCommunityFriends = (lang = "ru") =>
    `/${lang}/account/community/friends`;
export const getRouteCommunityPeople = (lang = "ru") =>
    `/${lang}/account/community/people`;
/**
 * Профиль человека. from — откуда открыли (профиль v2: «Назад», хлебная крошка, а из лиги — и
 * доступ к карточке): friends, people, chat, activity, league, link. Прежний экран его не читает.
 */
export const getRouteCommunityPerson = (
    lang = "ru",
    personId: string,
    from?: "league" | "friends" | "people" | "chat" | "activity" | "link",
) => `/${lang}/account/community/person/${encodeURIComponent(personId)}${from ? `?from=${from}` : ""}`;
/**
 * Страница создания встречи (как CreateActivityScreen приложения).
 * `date` — «YYYY-MM-DD»: календарь открывает её с уже выбранным днём (`?date=`).
 */
export const getRouteCommunityCreate = (lang = "ru", date?: string) =>
    `/${lang}/account/community/create${date ? `?date=${encodeURIComponent(date)}` : ""}`;
/** Страница клуба (как ClubScreen приложения): в меню её нет, ведёт Профиль → «Клуб». */
export const getRouteCommunityClub = (lang = "ru") =>
    `/${lang}/account/community/club`;
export const getRouteBlagostClubs = (lang = "ru") => `/${lang}/blagost-clubs`;
/** Кабинет руководителя клуба (`/club-manager[/<хвост>]?club=`). */
export const getRouteClubManager = (lang = "ru") => `/${lang}/club-manager`;
export const getRouteAiSearch = (lang = "ru") => `/${lang}/ai-search`;
export const getRoutePackages = (lang = "ru") => `/${lang}/packages`;
/**
 * Страница получателя подарка — без токена: сама ссылка /<lang>/gift/<token>
 * живёт только у покупателя, а в адресе сайта токен не остаётся
 * (features/gifts/lib/giftLink.ts).
 */
export const getRouteGift = (lang = "ru") => `/${lang}/gift`;
export const getRouteMyGifts = (lang = "ru") => `/${lang}/account/gifts`;

// Player routes
export const getRoutePlayer = (lang = "ru", mediaId?: string) => {
    if (mediaId) {
        return `/${lang}/player/${mediaId}`;
    }
    return `/${lang}/player`;
};

// Player with media ID (explicit function)
export const getRoutePlayerMedia = (lang = "ru", mediaId: string) =>
    `/${lang}/player/${mediaId}`;

// Player with options (quality, timestamp, etc.)
export const getRoutePlayerWithOptions = (
    lang = "ru",
    mediaId: string,
    options?: {
        quality?: string;
        autoplay?: boolean;
        timestamp?: number;
        subtitle?: string;
        volume?: number;
    },
) => {
    const params = new URLSearchParams();

    if (options?.quality) params.set("quality", options.quality);
    if (options?.autoplay) params.set("autoplay", "true");
    if (options?.timestamp !== undefined) {
        params.set("time", String(options.timestamp));
    }
    if (options?.subtitle) params.set("subtitle", options.subtitle);
    if (options?.volume) params.set("volume", String(options.volume));

    const query = params.toString();
    return `/${lang}/player/${mediaId}${query ? `?${query}` : ""}`;
};

const locales = ["ru", "en", "cn", "ar", "es", "de"];

export const AppRouteByPathPattern: Record<
    string,
    { route: AppRoutes; lang: string }
> = {
    [getRouteMain("en")]: { route: AppRoutes.MAIN, lang: "en" },
    [getRouteLogin("en")]: { route: AppRoutes.LOGIN, lang: "en" },
    [getRoutePlayer("en")]: { route: AppRoutes.PLAYER, lang: "en" },
    [getRouteCalculator("en")]: { route: AppRoutes.CALCULATOR, lang: "en" },
    [getRouteRag("en")]: { route: AppRoutes.RAG, lang: "en" },
    [getRouteTermsAndConditions("en")]: {
        route: AppRoutes.TermsAndConditions,
        lang: "en",
    },
    ...Object.fromEntries(
        locales.flatMap((lang) => [
            [`/${lang}`, { route: AppRoutes.MAIN, lang }],
            [`/${lang}/login`, { route: AppRoutes.LOGIN, lang }],
            [`/${lang}/player`, { route: AppRoutes.PLAYER, lang }],
            [`/${lang}/calc`, { route: AppRoutes.CALCULATOR, lang }],
            [`/${lang}/rag`, { route: AppRoutes.RAG, lang }],
            [
                `/${lang}/terms-and-conditions`,
                { route: AppRoutes.TermsAndConditions, lang },
            ],
        ]),
    ),
};
